import { Controller } from "@hotwired/stimulus"
import StartToastifyInstance from "toastify-js";

export default class extends Controller {
  static targets = ["files"]

  connect() {
    this.getAllowedFiles();
  }

  validate(event) {
    let firstAttempt = document.querySelector(`input[data-document*=${this.allowedFileNames[0]}]`)?.files
    let secondAttempt = document.querySelector(`input[data-document*=${this.allowedFileNames[1]}]`)?.files

    if (firstAttempt?.length == 0 && secondAttempt?.length == 0) {
      StartToastifyInstance({
        text: `Selecione ao menos um arquivo de ${this.allowedFileNames.join(' ou ')}.`,
        duration: 3000,
        close: true,
        gravity: "bottom",
        position: "center",
        backgroundColor: "#ff0000",
        stopOnFocus: true,
      }).showToast();
      event.preventDefault();
    }

    this.filesTargets.forEach((target) => {
      if (target.files.length == 0) {
        if (!this.allowedFileNames.includes(target.dataset.document.split(" ")[0].replaceAll(' ',''))) {
          StartToastifyInstance({
            text: `Selecione ao menos um arquivo para ${target.dataset.document}.`,
            duration: 3000,
            close: true,
            gravity: "bottom",
            position: "center",
            backgroundColor: "#ff0000",
            stopOnFocus: true,
          }).showToast();
          event.preventDefault();
          return;
        }
      }
    });

  }

  getAllowedFiles() {
    const fileNames = [];
    this.filesTargets.forEach((target) => {
      fileNames.push(target.dataset.document.split(" ")[0]);
    });
    const allowedFileNames = ["Diploma", "Declaração", "Certificado"];
    const filteredFileNames = fileNames.filter(name => allowedFileNames.includes(name));
    fileNames.length = 0;
    fileNames.push(...filteredFileNames);
    this.allowedFileNames = fileNames;
  }
}